module.exports = __webpack_public_path__ + "img/vn.27bfb255.svg";